import React, { useEffect, useState, useRef } from 'react';
import { motion } from 'framer-motion';
import { ArrowDownIcon, CheckCircle2Icon, CalendarIcon } from 'lucide-react';
function SonarGrid() {
  return <svg className="absolute inset-0 w-full h-full" viewBox="0 0 800 700" preserveAspectRatio="xMidYMid slice" xmlns="http://www.w3.org/2000/svg" style={{
    opacity: 0.09
  }} data-id="element-209">
      {[80, 180, 280, 380, 480, 580].map((r, i) => <circle key={i} cx="280" cy="360" r={r} stroke="#0066FF" strokeWidth="0.8" fill="none" data-id="element-210" />)}
      <line x1="280" y1="0" x2="280" y2="700" stroke="#0066FF" strokeWidth="0.5" data-id="element-211" />
      <line x1="0" y1="360" x2="800" y2="360" stroke="#0066FF" strokeWidth="0.5" data-id="element-212" />
      {[-60, -30, 0, 30, 60].map((angle, i) => {
      const rad = angle * Math.PI / 180;
      const x2 = 280 + 700 * Math.cos(rad);
      const y2 = 360 + 700 * Math.sin(rad);
      return <line key={i} x1="280" y1="360" x2={x2} y2={y2} stroke="#0066FF" strokeWidth="0.35" data-id="element-213" />;
    })}
    </svg>;
}
function SonarPulses() {
  return <div className="absolute pointer-events-none" style={{
    left: '25%',
    top: '55%',
    transform: 'translate(-50%, -50%)',
    width: 520,
    height: 520
  }} data-id="element-214">
      {[0, 1, 2, 3].map(i => <motion.div key={i} className="absolute inset-0 rounded-full" style={{
      border: '1.5px solid rgba(0, 102, 255, 0.4)'
    }} initial={{
      scale: 0,
      opacity: 0
    }} animate={{
      scale: [0, 1],
      opacity: [0.7, 0]
    }} transition={{
      duration: 4,
      repeat: Infinity,
      delay: i * 1.0,
      ease: 'easeOut'
    }} data-id="element-215" />)}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-3 h-3 rounded-full" style={{
      background: '#0066FF',
      boxShadow: '0 0 18px rgba(0,102,255,0.9)'
    }} data-id="element-216" />
    </div>;
}
function ParticleField() {
  const particles = Array.from({
    length: 16
  }, (_, i) => ({
    id: i,
    x: Math.random() * 52,
    y: Math.random() * 100,
    size: Math.random() * 2 + 1,
    delay: Math.random() * 5,
    duration: Math.random() * 6 + 6
  }));
  return <div className="absolute inset-0 overflow-hidden pointer-events-none" data-id="element-217">
      {particles.map(p => <motion.div key={p.id} className="absolute rounded-full" style={{
      left: `${p.x}%`,
      top: `${p.y}%`,
      width: p.size,
      height: p.size,
      background: '#4488FF'
    }} animate={{
      opacity: [0, 0.5, 0],
      scale: [0.8, 1.2, 0.8],
      y: [0, -15, 0]
    }} transition={{
      duration: p.duration,
      delay: p.delay,
      repeat: Infinity,
      ease: 'easeInOut'
    }} data-id="element-218" />)}
    </div>;
}
export function Hero() {
  return <section className="relative flex flex-col" style={{
    height: '100vh',
    minHeight: '700px',
    overflow: 'hidden',
    paddingTop: '80px'
  }} data-id="element-219">
      {/* ── URGENCY BANNER ── */}
      <motion.div className="relative z-30 flex items-center justify-center gap-3 px-6 py-3 text-center flex-shrink-0" style={{
      background: 'rgba(254,188,46,0.10)',
      borderBottom: '1px solid rgba(254,188,46,0.22)'
    }} initial={{
      opacity: 0,
      y: -8
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.5
    }} data-id="element-220">
        <motion.span className="w-2 h-2 rounded-full flex-shrink-0" style={{
        background: '#FEBC2E',
        boxShadow: '0 0 8px rgba(254,188,46,0.9)'
      }} animate={{
        scale: [1, 1.3, 1]
      }} transition={{
        duration: 2,
        repeat: Infinity
      }} data-id="element-221" />
        <span className="text-sm font-medium" style={{
        color: '#FFDFA0'
      }} data-id="element-222">
          <strong style={{
          color: '#FFE8B0',
          fontWeight: 800
        }} data-id="element-223">
            Platinum marktexclusiviteit:
          </strong>{' '}
          per markt werken we met maar één klant. In ons gesprek kijken we samen
          of jouw sector en regio nog vrij zijn.
        </span>
      </motion.div>

      {/* ── DARK LEFT BACKGROUND + SONAR ── */}
      <div className="absolute inset-0 z-0" style={{
      background: '#050A14'
    }} data-id="element-224">
        <SonarGrid data-id="element-225" />
        <SonarPulses data-id="element-226" />
        <ParticleField data-id="element-227" />
        <motion.div className="absolute top-0 left-0 rounded-full blur-3xl pointer-events-none" style={{
        width: 500,
        height: 500,
        background: 'radial-gradient(ellipse, rgba(0,82,204,0.20) 0%, transparent 70%)'
      }} animate={{
        scale: [1, 1.1, 1],
        opacity: [0.8, 1, 0.8]
      }} transition={{
        duration: 8,
        repeat: Infinity,
        ease: 'easeInOut'
      }} data-id="element-228" />
      </div>

      {/* ── RIGHT IMAGE — diagonal clip van rechts boven → links onder ── */}
      <div className="absolute inset-0 z-10" style={{
      clipPath: 'polygon(58% 0, 100% 0, 100% 100%, 42% 100%)',
      display: 'none'
    }} data-id="element-229">
        <div className="w-full h-full" style={{
        display: 'block'
      }} data-id="element-230">
          <img src="https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=1600&q=80&auto=format&fit=crop" alt="" className="w-full h-full" style={{
          objectFit: 'cover',
          opacity: 0.45
        }} data-id="element-231" />
          <div className="absolute inset-0" style={{
          background: 'linear-gradient(to bottom, rgba(5,10,20,0.25) 0%, rgba(5,10,20,0.55) 100%)'
        }} data-id="element-232" />
        </div>
      </div>

      {/* ── RIGHT IMAGE — responsive via media query workaround ── */}
      <style data-id="element-233">{`
        @media (min-width: 1024px) {
          .hero-img-panel { display: block !important; }
          .hero-diagonal-fade { display: block !important; }
        }
      `}</style>

      <div className="hero-img-panel absolute inset-0 z-10" style={{
      clipPath: 'polygon(58% 0, 100% 0, 100% 100%, 42% 100%)',
      display: 'none'
    }} data-id="element-234">
        <img src="https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=1600&q=80&auto=format&fit=crop" alt="" style={{
        width: '100%',
        height: '100%',
        objectFit: 'cover',
        opacity: 0.45
      }} data-id="element-235" />
        <div style={{
        position: 'absolute',
        inset: 0,
        background: 'linear-gradient(to bottom, rgba(5,10,20,0.2) 0%, rgba(5,10,20,0.5) 100%)'
      }} data-id="element-236" />
      </div>

      {/* ── DIAGONAL FADE — smooth blend between donker links en foto rechts ── */}
      <div className="hero-diagonal-fade absolute inset-0 z-20 pointer-events-none" style={{
      background: 'linear-gradient(103deg, #050A14 40%, rgba(5,10,20,0.7) 51%, transparent 62%)',
      display: 'none'
    }} data-id="element-237" />

      {/* ── CONTENT ── */}
      <div className="relative z-30 flex-1 flex items-center" data-id="element-238">
        <div className="w-full px-6" style={{
        maxWidth: 1200,
        margin: '0 auto'
      }} data-id="element-239">
          <div style={{
          maxWidth: '56%'
        }} data-id="element-240">
            {/* Badge */}
            <motion.div className="section-label-dark mb-8" initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6,
            type: 'spring',
            stiffness: 100
          }} data-id="element-241">
              <motion.span className="glow-dot" animate={{
              scale: [1, 1.2, 1]
            }} transition={{
              duration: 2,
              repeat: Infinity
            }} data-id="element-242" />
              Eerst peilen. Dan bouwen.
            </motion.div>

            {/* H1 */}
            <h1 className="font-black text-white mb-7 tracking-tight" style={{
            fontSize: 'clamp(2.8rem, 5vw, 4.2rem)',
            lineHeight: 1.22,
            paddingBottom: '0.18em'
          }} data-id="element-243">
              {['Iedereen', 'gooit', 'een', 'net.'].map((word, i) => <motion.span key={i} className="inline-block" style={{
              marginRight: '0.22em'
            }} initial={{
              opacity: 0,
              y: 50
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              delay: 0.1 + i * 0.08,
              duration: 0.6,
              type: 'spring',
              stiffness: 100
            }} data-id="element-244">
                  {word}
                </motion.span>)}
              <br data-id="element-245" />
              {['Wij', 'weten', 'waar', 'de', 'vis', 'zit.'].map((word, i) => <motion.span key={i} className="inline-block gradient-text" style={{
              marginRight: '0.22em'
            }} initial={{
              opacity: 0,
              y: 50
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              delay: 0.3 + i * 0.08,
              duration: 0.6,
              type: 'spring',
              stiffness: 100
            }} data-id="element-246">
                  {word}
                </motion.span>)}
            </h1>

            {/* Subtitle */}
            <motion.p className="text-white/60 leading-relaxed mb-10" style={{
            fontSize: 'clamp(1.05rem, 1.8vw, 1.2rem)',
            maxWidth: 480
          }} initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6,
            delay: 0.5,
            type: 'spring'
          }} data-id="element-247">
              CorePrint gebruikt 90 dagen aan{' '}
              <strong className="font-semibold" style={{
              color: 'rgba(255,255,255,0.85)'
            }} data-id="element-248">
                complexe test Google Ads-data
              </strong>{' '}
              als sonar. We bewijzen welke zoekwoorden in{' '}
              <em className="not-italic font-semibold" style={{
              color: 'rgba(255,255,255,0.85)'
            }} data-id="element-249">
                jouw markt
              </em>{' '}
              daadwerkelijk aanvragen opleveren, nog voordat we een euro in SEO
              steken.
            </motion.p>

            {/* CTAs */}
            <motion.div className="flex flex-wrap gap-4 mb-12" initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6,
            delay: 0.6,
            type: 'spring'
          }} data-id="element-250">
              <motion.a href="#gesprek" className="btn-primary" whileHover={{
              scale: 1.05
            }} whileTap={{
              scale: 0.95
            }} data-id="element-251">
                <CalendarIcon size={18} data-id="element-252" />
                Boek een presentatie
              </motion.a>
              <motion.a href="#hoe" className="btn-ghost-dark" whileHover={{
              scale: 1.05
            }} whileTap={{
              scale: 0.95
            }} data-id="element-253">
                Hoe het werkt <ArrowDownIcon size={16} data-id="element-254" />
              </motion.a>
            </motion.div>

            {/* Trust items */}
            <motion.div className="flex flex-nowrap items-center gap-y-4" style={{
            columnGap: '2rem'
          }} initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} transition={{
            duration: 0.6,
            delay: 0.75
          }} data-id="element-255">
              {['Vrijblijvend kennismaken', 'Jij blijft eigenaar over je eigen data'].map((t, i) => <motion.div key={t} className="flex items-center gap-2.5 text-white/50" style={{
              fontSize: '0.92rem'
            }} initial={{
              opacity: 0,
              x: -10
            }} animate={{
              opacity: 1,
              x: 0
            }} transition={{
              delay: 0.8 + i * 0.1,
              type: 'spring'
            }} data-id="element-256">
                  <CheckCircle2Icon size={16} className="text-brand-arctic" data-id="element-257" />
                  {t}
                </motion.div>)}
            </motion.div>
          </div>
        </div>
      </div>
    </section>;
}